import React from 'react'
import PropTypes from 'prop-types'
import RangeSlider from 'components/RangeSlider'
import ContainerDimentionsContext from 'components/ContainerDimentionsContext'
import RangeSliderWithContext from 'components/RangeSlider/RangeSliderWithContext'
import ChannelGroupSelector from 'containers/ChannelGroupSelector'
import SelectGroup from 'components/SelectGroup'
import Icon from 'components/Icon'
import Loader from 'components/Loader'
import Checkbox from 'components/Checkbox'
import {channelGroupList, channelTypeList} from '@divvit/common-channels'
import partial from 'utils/partial'
import classnames from 'classnames'
import pluralize from 'pluralize'
import map from 'lodash/map'
import Select from 'components/Select'
import {connect} from 'react-redux'
import {setConversionType} from 'redux/modules/currentUser/actions'
import {getConverionType} from 'redux/modules/currentUser/selectors'
import CountryMultiSelect from 'components/CountryMultiSelect'

const DAY = 24 * 60
const HOUR = 60

const touchpointsSections = [
  {
    key: 'first',
    title: 'First',
    type: 'channel',
    single: true
  },
  // {
  //   key: 'firstInterval',
  //   type: 'interval',
  //   align: 'center'
  // },
  // {
  //   key: 'second',
  //   title: 'Second',
  //   type: 'channel',
  //   align: 'center'
  // },
  {
    key: 'includes',
    title: 'Includes',
    type: 'channel',
    align: 'center',
    borders: true
  },
  // {
  //   key: 'penultimate',
  //   title: 'Before Last',
  //   type: 'channel',
  //   align: 'center'
  // },
  // {
  //   key: 'lastInterval',
  //   type: 'interval',
  //   align: 'center'
  // },
  {
    key: 'last',
    title: 'Last',
    type: 'channel',
    align: 'right',
    single: true
  }
]

const impressionSections = [
  {
    key: 'hasImpression',
    title: 'HAS IMPRESSION',
    type: 'hasImpression',
    align: 'center',
    borders: true
  }
]

const filterItems = {
  // orderTime: {
  //   title: 'Conversion Time',
  //   icon: 'time',
  //   type: 'slider',
  //   formatValue: value => formatDate(setHours(new Date(), value / 60), 'HH:00'),
  //   tooltip: (value, amount) => {
  //     const format = value => formatDate(setHours(new Date(), value / 60), 'HH:00')
  //     return `${amount} ${pluralize('conversion', amount)}${' '}
  //       ${pluralize('was', amount)} made between${' '}
  //       ${format(value)} and ${format(value + 60)}`
  //   }
  // },
  // productCount: {
  //   title: 'Product Count',
  //   icon: 'product',
  //   type: 'slider',
  //   tooltip: (value, amount) => {
  //     return `${amount} ${pluralize('conversion', amount)}${' '}
  //      ${pluralize('have', amount)} ${value}${' '}
  //      ${pluralize('product', value)}`
  //   },
  //   limit: 1
  // },
  sessionCount: {
    title: 'Touchpoints Before Conversion',
    icon: 'visit',
    type: 'slider',
    tooltip: (value, amount) => {
      return `${amount} ${pluralize('conversion', amount)}${' '}
       ${pluralize('have', amount)} ${value}${' '}
       ${pluralize('visits', value)} before purchase`
    },
    limit: 1
  }
  // customerType: {
  //   title: 'Customer Type',
  //   icon: 'customer',
  //   type: 'select'
  // }
}

export class AggrFilter extends React.Component {
  static propTypes = {
    touchpoints: PropTypes.object,
    onFilterChange: PropTypes.func,
    onFilterReset: PropTypes.func,
    onTouchpointChange: PropTypes.func,
    filters: PropTypes.object,
    disabled: PropTypes.bool,
    conversionType: PropTypes.string,
    setConversionType: PropTypes.func.isRequired,
    sessionsOnly: PropTypes.bool,
    onSessionsOnlyChange: PropTypes.func,
    countries: PropTypes.array
  }

  static defaultProps = {
    touchpoints: {}
  }

  conversions = [
    {
      name: 'Registration Finished',
      value: 'Reg finished'
    },
    {
      name: 'First Time Deposit',
      value: 'FTD'
    }
  ]

  onSelectConversion = item => {
    this.props.setConversionType(item.value)
  }

  render() {
    const {onFilterReset, disabled, sessionsOnly, onSessionsOnlyChange} = this.props

    const classNames = classnames('aggr-filter', {
      'is-disabled': disabled
    })

    return (
      <div className={classNames}>
        <div className='aggr-filter_header' style={{height: '80px'}}>
          <div className='aggr-filter_header_title'>Filters</div>
          <div className='aggr-filter_header_inner_left'>
            {this.renderCountryFilters()}
            <Select
              className='aggr-filter_header_select'
              value={this.props.conversionType}
              options={this.conversions}
              onSelect={this.onSelectConversion}
            />
            <div className='aggr-filter_header_sessions_only'>
              <span className='aggr-filter_header_sessions_only_label'>Filter for Sessions Only</span>
              <Checkbox
                align='right'
                color='default'
                checked={sessionsOnly}
                onChange={onSessionsOnlyChange}
              />
            </div>
            
            <div
              className='aggr-filter_header_reset'
              onClick={onFilterReset}
            >
              Reset all
            </div>
          </div>
        </div>
        <div className='aggr-filter_filters'>
          <div className='aggr-filter_filter'>
            <div className='aggr-filter_header is-dark'>
              <div className='aggr-filter_header_title'>
                Touchpoint Sequence
              </div>
            </div>
            <div className='aggr-filter_sequence'>
              {this.renderTouchpointSections()}
            </div>
          </div>
          {/* <div>
            <div className='aggr-filter_header is-dark'>
              <div className='aggr-filter_header_title' />
            </div>
            <div className='aggr-filter_sequence'>
              {this.renderImpressionSections()}
            </div>
          </div> */}
          {this.renderFilters()}
        </div>
      </div>
    )
  }

  renderFilters() {
    return Object.keys(filterItems).map((filter, index) => {
      return this.renderFilter(filter, index)
    })
  }

  renderCountryFilters() {
    const {onFilterChange, countries} = this.props
    const data = this.getFiltersData('countries')
    return (
      <div className='orders-filter_header_country'>
        <CountryMultiSelect countries={countries} onChange={partial(onFilterChange, 'countries')} values={data} />
      </div>
    )
  }

  renderFilter(filter, index) {
    const {title, icon} = filterItems[filter]

    return (
      <div className='aggr-filter_filter' key={index}>
        <div className='aggr-filter_filter_title'>
          {this.renderFilterIcon(icon)}
          {title}
        </div>
        <div className='aggr-filter_filter_body'>
          {this.renderFilterControl(filter)}
        </div>
      </div>
    )
  }

  renderFilterIcon(icon) {
    if (!icon) return null

    return (
      <Icon className='aggr-filter_filter_title_icon' name={icon} size='14px' />
    )
  }

  renderFilterControl(filter) {
    const {onFilterChange, disabled} = this.props
    const {type, formatValue, limit, tooltip} = filterItems[filter]
    const data = this.getFiltersData(filter)

    if (!data) return <Loader />

    if (type === 'slider') {
      const {
        chartData,
        step,
        xAxisKey,
        dataKey,
        limits: {min, max},
        values
      } = data
      return (
        <ContainerDimentionsContext className='aggr-filter_slider'>
          <RangeSliderWithContext
            disabled={disabled}
            min={min}
            max={max}
            values={values}
            chartData={chartData}
            dataKey={dataKey}
            xAxisKey={xAxisKey}
            step={step}
            onSelect={partial(onFilterChange, filter)}
            formatValue={formatValue}
            tooltip={tooltip}
            limit={limit}
          />
        </ContainerDimentionsContext>
      )
    } else {
      return (
        <SelectGroup
          disabled={disabled}
          className='aggr-filter_group'
          values={[
            {value: 'any', label: 'Any'},
            {value: 'new', label: 'New'},
            {value: 'repeat', label: 'Ret.'}
          ]}
          selected={data}
          onSelect={partial(onFilterChange, filter)}
        />
      )
    }
  }

  renderTouchpointSections() {
    return map(touchpointsSections, (section, index) => {
      return this.renderSection(section, index)
    })
  }

  renderImpressionSections() {
    return map(impressionSections, (section, index) => {
      return this.renderSection(section, index)
    })
  }

  renderSection(section, index) {
    const {title, align, borders} = section
    const classNames = classnames('aggr-filter_sequence_item', {
      'is-left': align === 'left',
      'is-center': align === 'center',
      'is-right': align === 'right',
      'with-borders': borders
    })

    return (
      <div className={classNames} key={index}>
        <div className='aggr-filter_sequence_item_title'>{title}</div>
        <div className='aggr-filter_sequence_item_body'>
          {this.renderSectionControl(section)}
        </div>
      </div>
    )
  }

  renderSectionControl(section) {
    const {touchpoints, onTouchpointChange, disabled} = this.props
    const {type, key, single} = section
    const values = touchpoints[key]
    const types = touchpoints[key + "ChannelTypes"]  

    if (type === 'channel') {
      return (
        <ChannelGroupSelector
          disabled={disabled}
          className='aggr-filter_sequence_item_channel'
          groups={channelGroupList}
          channelTypes={channelTypeList}
          selected={values}
          types={types}
          onSelect={partial(onTouchpointChange, key)}
          isSingle={single}
        />
      )
    } else if (type === 'hasImpression') {
      const classNames = classnames('channel-icon_icon', {
        [`channel-group-selector_any`]: !values
      })
      return (
        <div
          className='channel-group-selector is-empty'
          onClick={partial(onTouchpointChange, key, !values)}
        >
          <Icon disabled={disabled} className={classNames} name={`eye`} />
        </div>
      )
    } else {
      return (
        <RangeSlider
          className='aggr-filter_sequence_item_interval'
          title='Interval'
          disabled={disabled}
          min={0}
          max={30 * DAY}
          stepValues={[
            0,
            5,
            15,
            30,
            1 * HOUR,
            2 * HOUR,
            5 * HOUR,
            12 * HOUR,
            1 * DAY,
            3 * DAY,
            5 * DAY,
            15 * DAY,
            30 * DAY
          ]}
          values={values}
          showEmptyPlaceholders
          showClearIcon
          onSelect={partial(onTouchpointChange, key)}
          formatValue={value => {
            const days = Math.floor(value / DAY)
            const hours = Math.floor(value / HOUR)
            if (days) {
              return `${days}d`
            } else if (hours) {
              return `${hours}h`
            } else {
              return `${value}m`
            }
          }}
        />
      )
    }
  }

  getFiltersData(filter) {
    console.log('getFiltersData', filter)
    const {filters} = this.props
    if (!filters) return null

    return filters[filter]
  }
}

const mapStateToProps = (state, props) => {
  const conversionType = getConverionType(state)
  return {
    conversionType
  }
}

export default connect(mapStateToProps, {
  setConversionType
})(AggrFilter)



// WEBPACK FOOTER //
// ./client/views/AggreatedAttributionView/AggrFilter.js